import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Alert,
  Image,
} from "react-bootstrap";

const FeederHome = () => {
  const [formData, setFormData] = useState({
    HM_Title: "",
    HM_Lead: "",
    HM_Description: "",
    HM_Section: "",
    HM_Country: "",
    HM_Image: "",
  });

  const [homeMasters, setHomeMasters] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Available sections matching your RSS categories
  const sections = [
    { value: "bharat", label: "Bharat" },
    { value: "global", label: "Global" },
    { value: "sports", label: "Sports" },
    { value: "finance", label: "Finance" },
    { value: "cricket", label: "Cricket" },
    { value: "golf", label: "Golf" },
    { value: "hockey", label: "Hockey" },
    { value: "nfl", label: "NFL" },
    { value: "nba", label: "NBA" },
    { value: "soccer", label: "Soccer" },
    { value: "chess", label: "Chess" },
    { value: "nhl", label: "NHL" },
    { value: "mlb", label: "MLB" },
    { value: "tennis", label: "Tennis" },
    { value: "auto", label: "Auto" },
    { value: "technology", label: "Technology" },
  ];

  // Fetch initial data
  useEffect(() => {
    fetchHomeMasters();
  }, []);

  const fetchHomeMasters = () => {
    fetch("https://www.bharatabroad.com/api/homemasters")
      .then((res) => res.json())
      .then((data) => setHomeMasters(data))
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Failed to load home master data.");
      });
  };

  // Handle input change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const res = await fetch("https://www.bharatabroad.com/api/homemasters", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Failed to publish");

      const newEntry = await res.json();
      setHomeMasters((prev) => [...prev, newEntry]);

      setFormData({
        HM_Title: "",
        HM_Lead: "",
        HM_Description: "",
        HM_Section: "",
        HM_Country: "",
        HM_Image: "",
      });

      setSuccess("Article published successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      console.error("Error publishing entry:", err);
      setError("Failed to publish entry.");
    }
  };

  // Delete item
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this article?")) {
      return;
    }

    try {
      const res = await fetch(
        `https://www.bharatabroad.com/api/homemasters/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!res.ok) throw new Error("Failed to delete");

      setHomeMasters((prev) => prev.filter((entry) => entry.id !== id));
      setSuccess("Article deleted successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      console.error("Error deleting entry:", err);
      setError("Failed to delete entry.");
    }
  };

  return (
    <Container className="my-5">
      <h2 className="text-center text-primary mb-4">
        Admin: Publish Home Master
      </h2>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError("")}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert variant="success" dismissible onClose={() => setSuccess("")}>
          {success}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="HM_Title">
              <Form.Label>
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="HM_Title"
                value={formData.HM_Title}
                onChange={handleChange}
                placeholder="Enter title"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="HM_Section">
              <Form.Label>
                Section <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="HM_Section"
                value={formData.HM_Section}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Section --</option>
                {sections.map((section) => (
                  <option key={section.value} value={section.value}>
                    {section.label}
                  </option>
                ))}
              </Form.Select>
              <Form.Text className="text-muted">
                This determines which page the article appears on
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={12}>
            <Form.Group controlId="HM_Lead">
              <Form.Label>Lead</Form.Label>
              <Form.Control
                type="text"
                name="HM_Lead"
                value={formData.HM_Lead}
                onChange={handleChange}
                placeholder="Enter lead/summary (optional)"
              />
              <Form.Text className="text-muted">
                Short summary shown below the title
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={12}>
            <Form.Group controlId="HM_Image">
              <Form.Label>
                Image URL <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="url"
                name="HM_Image"
                value={formData.HM_Image}
                onChange={handleChange}
                placeholder="https://example.com/image.jpg"
                required
              />
              {formData.HM_Image && (
                <div className="mt-3">
                  <p className="mb-2">
                    <strong>Preview:</strong>
                  </p>
                  <Image
                    src={formData.HM_Image}
                    alt="Preview"
                    className="img-fluid"
                    style={{
                      maxHeight: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                    thumbnail
                  />
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3" controlId="HM_Description">
          <Form.Label>
            Description <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="HM_Description"
            value={formData.HM_Description}
            onChange={handleChange}
            placeholder="Enter full article description"
            required
          />
          <Form.Text className="text-muted">
            Full article content to display in the featured card
          </Form.Text>
        </Form.Group>

        <div className="text-center">
          <Button variant="primary" type="submit" size="lg" className="px-5">
            📰 Publish Article
          </Button>
        </div>
      </Form>

      <hr className="my-5" />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Published Articles ({homeMasters.length})</h4>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={fetchHomeMasters}
        >
          🔄 Refresh
        </Button>
      </div>

      {homeMasters.length === 0 ? (
        <Alert variant="info">No articles published yet.</Alert>
      ) : (
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr>
              <th style={{ width: "50px" }}>ID</th>
              <th style={{ width: "250px" }}>Title</th>
              <th style={{ width: "120px" }}>Section</th>
              <th style={{ width: "100px" }}>Country</th>
              <th style={{ width: "150px" }}>Lead</th>
              <th>Description</th>
              <th style={{ width: "100px" }}>Image</th>
              <th style={{ width: "100px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {homeMasters.map((entry) => (
              <tr key={entry.id}>
                <td>{entry.id}</td>
                <td>
                  <strong>{entry.HM_Title}</strong>
                </td>
                <td>
                  <span className="badge bg-primary">
                    {entry.HM_Section || "N/A"}
                  </span>
                </td>
                <td>
                  <small>{entry.HM_Country || "—"}</small>
                </td>
                <td>
                  <small>
                    {entry.HM_Lead ? entry.HM_Lead.slice(0, 50) + "..." : "—"}
                  </small>
                </td>
                <td>
                  <small>
                    {entry.HM_Description
                      ? entry.HM_Description.slice(0, 80) + "..."
                      : "—"}
                  </small>
                </td>
                <td>
                  {entry.HM_Image ? (
                    <img
                      src={entry.HM_Image}
                      alt="preview"
                      style={{
                        height: "60px",
                        width: "80px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  ) : (
                    <span className="text-muted">No image</span>
                  )}
                </td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(entry.id)}
                  >
                    🗑️ Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default FeederHome;
